export const viewHeight = 600;
export const itemHeaderHeight = 30;
export const itemTextAreaHeight = 90;
export const itemSubItemHeight = 30;
export const portHeight = 10;
export const portWidth = 10;
export const portRadius = 10;
export const betweenItemsAreaIfPositionsIsZero = 50;